/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './home-page-template.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from 'nm-socle-application/app/shared/directives/loader-directive';
import * as i4 from 'nm-socle-application/app/shared/templates/home-page-template/home-page-template.component';
import * as i5 from 'nm-socle-application/app/shared/services/template-init.service';
import * as i6 from 'nm-socle-application/app/shared/services/component-manager.service';
const styles_HomePageTemplateComponent:any[] = [i0.styles];
export const RenderType_HomePageTemplateComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_HomePageTemplateComponent,data:{}});
function View_HomePageTemplateComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(0,(null as any),(null as any),0))],(null as any),
      (null as any));
}
function View_HomePageTemplateComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),5,'div',([] as any[]),
      [[8,'className',0]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,278528,(null as any),0,i2.NgStyle,[i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer],{ngStyle:[0,'ngStyle']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,
          (null as any),View_HomePageTemplateComponent_2)),i1.ɵdid(4,16384,[[1,4]],
          0,i3.LoaderDirective,[i1.ViewContainerRef],{loaderName:[0,'loaderName']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.customStyles;
    _ck(_v,1,0,currVal_1);
    const currVal_2:any = 'leftSide';
    _ck(_v,4,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵinlineInterpolate(1,'side left ',_co.leftSideSize,'');
    _ck(_v,0,0,currVal_0);
  });
}
function View_HomePageTemplateComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(0,(null as any),(null as any),0))],(null as any),
      (null as any));
}
function View_HomePageTemplateComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(0,(null as any),(null as any),0))],(null as any),
      (null as any));
}
function View_HomePageTemplateComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),5,'div',([] as any[]),
      [[8,'className',0]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,278528,(null as any),0,i2.NgStyle,[i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer],{ngStyle:[0,'ngStyle']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,
          (null as any),View_HomePageTemplateComponent_5)),i1.ɵdid(4,16384,[[1,4]],
          0,i3.LoaderDirective,[i1.ViewContainerRef],{loaderName:[0,'loaderName']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.customStyles;
    _ck(_v,1,0,currVal_1);
    const currVal_2:any = 'rightSide';
    _ck(_v,4,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵinlineInterpolate(1,'side right ',_co.rightSideSize,
        '');
    _ck(_v,0,0,currVal_0);
  });
}
export function View_HomePageTemplateComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(2,[i1.ɵqud(671088640,1,{loaderHosts:1}),(_l()(),i1.ɵeld(1,0,(null as any),
      (null as any),14,'div',[['class','container']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HomePageTemplateComponent_1)),
      i1.ɵdid(4,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(6,0,(null as any),(null as any),5,'div',[['class','main']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(7,278528,
          (null as any),0,i2.NgStyle,[i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],
          {ngStyle:[0,'ngStyle']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,
          (null as any),View_HomePageTemplateComponent_3)),i1.ɵdid(10,16384,[[1,4]],
          0,i3.LoaderDirective,[i1.ViewContainerRef],{loaderName:[0,'loaderName']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_HomePageTemplateComponent_4)),i1.ɵdid(14,16384,(null as any),
          0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        var _co:i4.HomePageTemplateComponent = _v.component;
        const currVal_0:any = _co.hasSide;
        _ck(_v,4,0,currVal_0);
        const currVal_1:any = _co.customStyles;
        _ck(_v,7,0,currVal_1);
        const currVal_2:any = 'main';
        _ck(_v,10,0,currVal_2);
        const currVal_3:any = _co.hasSide;
        _ck(_v,14,0,currVal_3);
      },(null as any));
}
export function View_HomePageTemplateComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'home-page-template',
      ([] as any[]),(null as any),(null as any),(null as any),View_HomePageTemplateComponent_0,
      RenderType_HomePageTemplateComponent)),i1.ɵdid(1,7585792,(null as any),0,i4.HomePageTemplateComponent,
      [i1.ChangeDetectorRef,i5.TemplateInitService,i6.ComponentsManagerService],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const HomePageTemplateComponentNgFactory:i1.ComponentFactory<i4.HomePageTemplateComponent> = i1.ɵccf('home-page-template',
    i4.HomePageTemplateComponent,View_HomePageTemplateComponent_Host_0,{misc:'misc'},
    {closeEvent:'closeEvent',internalStateEvent:'internalStateEvent'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/src/$$_gendir/node_modules/nm-socle-application/app/shared/templates/home-page-template/home-page-template.component.ngfactory.ts